import * as React from 'react';

import States from 'login-constants/states';
import * as userUtils from 'login-utils/userUtils';
import * as featureFlags from 'login-utils/featureFlags';
import withUserStateCookie from './withUserStateCookie';
import LoginLink from './LoginLink';

export const UserStateLink = ({ userStateUrl }) => {
  const userLoggedIn = featureFlags.isEnabled('applicationChooserInDropdownMenu20190109') && userUtils.getCurrentUser();
  return userLoggedIn ? null : (
    <LoginLink href={`/${userStateUrl}`}>
      Already started an application? We'll help you pick up where you left off
    </LoginLink>
  );
};

export default withUserStateCookie(UserStateLink)({
  provisional: States.REQUEST_RESET_PASSWORD,
  full: States.LOGIN,
});
